import React from 'react';
import { BrowserRouter as Router, Switch, Route, RouteProps, RouteComponentProps, Redirect } from 'react-router-dom';
import 'antd/dist/antd.css';
import '@/App/app.css';

import IndividualGachaRouter from '@/App/IndividualGachaRouter';
import ScrollToTop from '@/App/ScrollToTop';
import TopRouter from '@/App/TopRouter';
import SendEmailPage from '@/Email/pages/SendEmailPage';
import SendEmailToAllPage from '@/EmailToAll/pages/SendEmailToAllPage';
import CreateGacha from '@/Gacha/pages/CreateGacha';
import ListGacha from '@/Gacha/pages/ListGacha';
import ShowGachaDetail from '@/Gacha/pages/ShowGachaDetail';
import UpdateGacha from '@/Gacha/pages/UpdateGacha';
import ListGachaRegister from '@/GachaRegister/page/ListGachaRegister';
import ListGachaWinning from '@/GachaWinning/pages/ListGachaWinning';
import ListGachaWinningUnapproved from '@/GachaWinning/pages/ListGachaWinningUnapproved';
import AddGiftCode from '@/GiftCode/pages/AddGiftCode';
import ListGiftCode from '@/GiftCode/pages/ListGiftCode';
import ExportAllRegistersAsCsv from '@/Top/pages/ExportAllRegistersAsCsv';
import { ROUTES } from '@/constants';
import UserContext from '@/hooks/context/UserContext';

interface RoutePropsWithSubRoute extends RouteProps {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>
    | React.FunctionComponent<RouteProps[]>;
  routes?: RouteProps[];
}

const routes: RoutePropsWithSubRoute[] = [
  {
    path: ROUTES.top,
    component: TopRouter,
    routes: [
      {
        path: ROUTES.topGacha,
        component: ListGacha,
        exact: true,
      },
      {
        path: ROUTES.topGachaCreate,
        component: CreateGacha,
        exact: true,
      },
      {
        path: ROUTES.topEmailSend,
        component: SendEmailToAllPage,
        exact: true,
      },
      {
        path: ROUTES.topExportAllRegistersAsCsv,
        component: ExportAllRegistersAsCsv,
        exact: true,
      },
      {
        path: ROUTES.top,
        exact: true,
        component: () => <Redirect to={ROUTES.topGacha} />,
      },
    ],
  },
  {
    path: '/gacha/:gachaId',
    component: IndividualGachaRouter,
    routes: [
      {
        path: '/gacha/:gachaId',
        component: ShowGachaDetail,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/update',
        component: UpdateGacha,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/gift-code/add',
        component: AddGiftCode,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/gift-code',
        component: ListGiftCode,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/winning',
        component: ListGachaWinning,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/winning/unapproved',
        component: ListGachaWinningUnapproved,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/register',
        component: ListGachaRegister,
        exact: true,
      },
      {
        path: '/gacha/:gachaId/email/send',
        component: SendEmailPage,
        exact: true,
      },
    ],
  },
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={ROUTES.top} />,
  },
];

const App: React.FC = () => (
  <Router>
    <UserContext>
      <ScrollToTop />
      <div className="app">
        <Switch>
          {routes.map((route, i) => (
            <Route
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              path={route.path}
              exact={route.exact}
              // eslint-disable-next-line react/jsx-props-no-spreading
              render={(props) => <route.component {...props} routes={route.routes} />}
            />
          ))}
        </Switch>
      </div>
    </UserContext>
  </Router>
);

export default App;
